export default "__VITE_ASSET__BPY9Dgic__"